
import {
  Vue, Component, Prop, Mixins,
} from 'vue-property-decorator';
import QueryStringTable from '@/features/query-string/components/QueryStringTable.vue';
import { EndpointItem } from '@/features/query-string/views/QueryString.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { copyTextToClipboard } from '@/features/common/helpers';

@Component({
  components: {
    QueryStringTable,
  },
})
export default class QueryStringDocs extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) item!: EndpointItem;

  private isCopied = false;

  private copyApiKeyToClipboard(text: string) {
    copyTextToClipboard(text);

    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }

  private goTo(where: string) {
    const section = this.$refs[where] as Vue;
    ((section.$el ? section.$el : section) as HTMLElement).scrollIntoView({ behavior: 'smooth' });
  }
}
